import ImgOne from '../../assets/icon-1.svg'
import ImgTwo from '../../assets/icon-2.svg'
import ImgThree from '../../assets/icon-3.svg'
import ImgFour from '../../assets/icon-4.svg'
import ImgFive from '../../assets/icon-5.svg'
import ImgSix from '../../assets/icon-6.svg'

const ServicesData = [
  {
    img: ImgOne,
    title: 'Alignment Specialist',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'

  },
  {
    img: ImgTwo,
    title: 'Cosmetic Dentistry',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'

  },
  {
    img: ImgThree,
    title: 'Oral Hygiene Experts',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'

  },
  {
    img: ImgFour,
    title: 'Root Canal Specialist',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'

  },
  {
    img: ImgFive,
    title: 'Live Dental Advisory',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'

  },
  {
    img: ImgSix,
    title: 'Cavity Inspection',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'
  }
]

export default ServicesData